import { LinkProps } from "@tanstack/react-router";
import { FC } from "react";
import { RouteLink } from "../RouteLink";

import { cn } from "../../../utils";

export type TBrandProps = { className?: string; to?: LinkProps["to"]; compact?: boolean };

export const Brand: FC<TBrandProps> = ({ className, to = "/", compact = false }) => {
  return (
    <RouteLink
      to={to}
      className={cn("flex items-center justify-center gap-2", className)}
    >
      {compact ? (
        <span className="text-xl font-bold">F</span>
      ) : (
        <span className="text-xl font-bold">FUNDY</span>
      )}
    </RouteLink>
  );
};
